import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Tooltip, Spin } from 'antd';
import {
    ScheduleOutlined
} from '@ant-design/icons';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import FormRegister from '../FormRegister'
import { CollectionServer, GET, IfElse, publish, QueryOrder, QueryParam, updateArrayInArray, useAuth } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function StatusBlock(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const { filters, compact, uuid } = props;
    const [readallspin, setReadallspin] = useState(false);
    const [spin, setSpin] = useState({});

    const action = (status, document, values, unlock, close, { collection, setCollection }) => {
        setSpin({ ...spin, [status.ID]: true })

        POST(auth, `/api/status`, {
            status: status,
            button: document,
            document: values
        }, ({ data }) => {
            if (data.status) {
                setCollection(updateArrayInArray(collection, data.status))
                publish(`service.status.${uuid}`, [...data.status])
            }
            if (close) {
                close();
            }
            setSpin({ ...spin, [status.ID]: false });
        }, errorCatch);

        if (unlock) {
            unlock();
        }
    };
    const markAsReaded = (collection, setCollection) => {
        setReadallspin(true);
        var arr = collection.filter(s => s.tipNovayaInfa);
        if (arr.length > 0) {
            GET(auth, `/api/status/read-all`, 
                ({ data }) => {
                    setCollection([])
                    // publish(`service.status.${uuid}`, [])
                    publish(`service.status.clear`, [])
                    setReadallspin(false);
                }, errorCatch);
        }
    };
    const date = (item) => {
        if (item && item.status && item.status.dataPoslednegoIzmeneniya) {
            var time = dayjs(item.status.dataPoslednegoIzmeneniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm');
            if (item.tipNovayaInfa) {
                return (
                    // <Badge status="processing" style={{cursor:"pointer"}} onClick={() => action(item, item.tipKnopkaOKDokument)} text={<span style={{ fontSize: "12px", fontWeight: "600"}}>{time}</span>} />
                    <div style={{
                        color: "rgba(0, 0, 0, 0.65)",
                        fontSize: "12px", marginTop: "3px", fontWeight: "600", cursor: "pointer"
                    }}>{time}</div>
                );
            } else {
                return (
                    <div style={{
                        color: "rgba(0, 0, 0, 0.65)",
                        fontSize: "12px", marginTop: "3px"
                    }}>{time}</div>
                );
            }
        }
    };
    const getFormForItem = (item) => {
        if (item.tipKnopkaPodtverditDokument) {
            return FormRegister(item.tipKnopkaPodtverditDokument);
        }
        if (item.tipKnopkaOtkazatsyaDokument) {
            return FormRegister(item.tipKnopkaOtkazatsyaDokument);
        }
        if (item.tipKnopkaViitiDokument) {
            return FormRegister(item.tipKnopkaViitiDokument);
        }
        if (item.tipKnopkaOKDokument) {
            return FormRegister(item.tipKnopkaOKDokument);
        }
        return undefined;
    };
    const ui = (item, collection, setCollection) => {
        return (<div key={item.ID}>
            {compact && <div style={{ margin: "0px 5px 10px 5px", borderBottom: "1px solid #eee" }}>
                <Spin spinning={spin[item.ID] === true ? true : false}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div>
                            <div style={{ color: "rgba(0, 0, 0, 0.45)" }}>{date(item)}</div>
                            {!item.tipNovayaInfa && <div style={{ fontSize: "12px" }}>{item.tekstStatusa}</div>}
                            {item.tipNovayaInfa && <div style={{ fontSize: "12px", fontWeight: "600", cursor: "pointer" }} onClick={() => action(item, "read", undefined, undefined, undefined, { collection, setCollection })}>{item.tekstStatusa}</div>}
                        </div>
                    </div>
                </Spin>
            </div>
            }
            {!compact && <div key={item.ID} style={{ margin: "0px 10px", borderBottom: "1px solid #eee" }}>
                <Spin spinning={spin[item.ID] === true ? true : false}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ flexBasis: "85px", color: "rgba(0, 0, 0, 0.45)" }}>{date(item)}</div>
                        {!item.tipNovayaInfa && <div style={{ flexBasis: "100%" }}>{item.tekstStatusa}</div>}
                        {item.tipNovayaInfa && <div style={{ flexBasis: "100%", fontWeight: "600", cursor: "pointer" }} onClick={() => action(item, "read", undefined, undefined, undefined, { collection, setCollection })}>{item.tekstStatusa}</div>}
                    </div>
                </Spin>
            </div>}
        </div>
        );
    };
    return (
        <div style={{ backgroundColor: "white", borderRadius:"4px" }}>
            <div style={{ padding: (compact) ? "0px 10px" : "10px" }}>
                <CollectionServer
                    // onCollectionChange={(collection) => {
                    //     publish(`service.status.${uuid}`, [...collection])
                    //     console.log("publish",`service.status.${uuid}`);
                    // }}
                    subscribe={{
                        name: "service.status",
                        filter: `service.status.${uuid}`,
                        func: (data, { msg, collection, setCollection, setCollectionItem, removeCollectionItem, request, state }) => {
                            request()
                        }
                    }}
                    name={"InterfeisiInfrastrukturnikhStatusov"}
                    auth={auth}
                    size="small"
                    source={'/api/query/InterfeisiInfrastrukturnikhStatusov'}
                    contextFilters={() => [
                        QueryOrder("TipNovayaInfa", "DESC"),
                        QueryOrder("status.DataPoslednegoIzmeneniya", "DESC"),
                        QueryParam("w-status.Arkhiv", "false"),
                        IfElse(compact, QueryParam("w-TipNovayaInfa", "true"), undefined),
                    ]}
                    filters={filters}
                    mode={"list"}
                    render={(item, idx, { collection, setCollection, setCollectionItem, update }) => {
                        return ui(item, collection, setCollection)
                    }}
                    collectionActions={() => [{
                        mode: "func",
                        trigger: (click) => (
                            <Tooltip title="Прочитано">
                                <Button loading={readallspin} style={{ border: "none" }} size="small" onClick={click}><ScheduleOutlined /></Button>
                            </Tooltip>
                        ),
                        action: (values, unlock, close, { collection, setCollection }) => {
                            markAsReaded(collection, setCollection)
                        },
                    }]}
                    modelActions={(item) => {
                        var actionForm = getFormForItem(item);
                        return [
                            ...IfElse(!!item.tipKnopkaPodtverdit, [{
                                ...props,
                                auth: auth,
                                mode: "MenuItem",
                                object: item,
                                action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaPodtverditDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                                callback: () => {
                                    // request
                                },
                                title: item.tipKnopkaPodtverdit,
                                form: actionForm,
                                document: item.tipKnopkaPodtverditDokument.toLowerCase()
                            }], []),
                            ...IfElse(!!item.tipKnopkaOtkazatsya, [{
                                ...props,
                                auth: auth,
                                mode: "MenuItem",
                                object: item,
                                action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaOtkazatsyaDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                                callback: () => {
                                    // request
                                },
                                title: item.tipKnopkaOtkazatsya,
                                form: actionForm,
                                document: item.tipKnopkaOtkazatsyaDokument.toLowerCase()
                            }], []),
                            ...IfElse(!!item.tipKnopkaViiti, [{
                                ...props,
                                auth: auth,
                                mode: "MenuItem",
                                object: item,
                                action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaViitiDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                                callback: () => {
                                    // request
                                },
                                title: item.tipKnopkaViiti,
                                form: actionForm,
                                document: item.tipKnopkaViitiDokument.toLowerCase()
                            }], []),
                            ...IfElse(!!item.tipKnopkaOK, [{
                                ...props,
                                auth: auth,
                                mode: "MenuItem",
                                object: item,
                                action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaOKDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                                callback: () => {
                                    // request
                                },
                                title: item.tipKnopkaOK,
                                form: actionForm,
                                document: item.tipKnopkaOKDokument.toLowerCase()
                            }], [])
                        ]
                    }}
                />
            </div>
        </div>
    );
}
